import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { EmptyTestsAndResults } from '@innovamat/glimmer-assets';
import { Typography } from '@innovamat/glimmer-components';

const Container = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
`;

const TextContainer = styled.div`
  text-align: center;
`;

const StyledSubtitle = styled(Typography.Body1)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
`;

const StyledImage = styled(EmptyTestsAndResults)`
  margin-top: 3.5rem;
`;

const TestsAndResultsEmptyState = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <StyledImage />
      <TextContainer>
        <Typography.H4>
          {t('testsAndResultsView.emptyState.title')}
        </Typography.H4>
        <StyledSubtitle>
          {t('testsAndResultsView.emptyState.subtitle')}
        </StyledSubtitle>
      </TextContainer>
    </Container>
  );
};

export { TestsAndResultsEmptyState };
